import React from "react";

import { useStoreState } from "easy-peasy";

import { useToast } from "../../../hooks/useToast.jsx";


import UploadFilesComponent from "./UploadFilesComponent.jsx";


const UploadFilesFormComponent = ({ entityName, entity, postFunction, onSuccess }) => {

    const { apiData: { ACTIONS, BACKOFFICE_DEFAULT_VALUES } } = useStoreState(state => state.actionSlugs);

    const { fileContraints } = BACKOFFICE_DEFAULT_VALUES;
    const { csrfToken } = ACTIONS[entityName+"s"]['editFiles'];

	const toast = useToast();

    const { uploadFilesContainer, arrayOfNewFiles, arrayOfFilesToEdit, arrayOfFilesToDelete, replaceAll } = UploadFilesComponent({
		filesMainEntityName: entityName,
		filesToUpdate: entity?.files ?? null,
	});

    const checkData = () => {
		let errorList = {};
		
		let formData = new FormData ();

        for (const element of arrayOfNewFiles) {
            if (fileContraints.FORBIDDEN_NAMES.video?.includes(element.fileName)) {
				errorList.push('Nom de fichiers interdits : ' + fileContraints.FORBIDDEN_NAMES.video?.join(", "));
				break;
			}
            if (element.file && element.fileName == "") {
				errorList.push('Veuillez nommer vos nouveaux fichiers');
				break;
			}
		}

		if (arrayOfFilesToEdit) {
            for (const element of arrayOfFilesToEdit) {
                if (element?.edit == true) {
                    if (fileContraints.FORBIDDEN_NAMES.video?.includes(element.newFile.fileName)) {
						errorList.push('Nom de fichiers interdits : ' + fileContraints.FORBIDDEN_NAMES.video?.join(", "));
						break;
					}
                    if (element.newFile.fileName == "") {
						errorList.push('Veuillez nommer vos fichiers à éditer');
						break;
					}
				}
			}
		}

        if (Object.keys(errorList).length) {
			toast.open({ message: Object.values(errorList)?.join(', '), variant: "danger" });
		}
        else {
            populateFormData(formData);
            postFunction({formData, uniqueId: entity?.uniqueId})
                .then(() => {
					onSuccess?.();
            })
            .catch((error) => {
                    handleBadRequest(error);
            })
        }
	}


	const handleBadRequest = (error) => {
		const errorList = {};
		if (error?.errors) {
			for (const key of Object.keys(error.errors)) {
				errorList[key] = error.errors[key]
			}
		}
		errorList.global = 'Il y a eu un probleme lors de l\'enregistrement de la video';
	}


	const populateFormData = (formData) => {
		let toDelete = arrayOfFilesToDelete;
		if (replaceAll) {
			toDelete = arrayOfFilesToEdit.map((file) => { return file.uniqueId });
		}

		let index = 0;

		arrayOfNewFiles?.forEach((item) => {
			if (!item.file) return;

			let newName = item.fileName.includes(".")
				? item.fileName
				: `${item.fileName}.${item.fileExtension}`;

			formData.append(`files[${index}][file]`, item.file);
			formData.append(`files[${index}][type]`, "new");
			formData.append(`files[${index}][nameForHeadset]`, newName);

			index++;
		});

		for (const uuidToDelete of toDelete) {
			formData.append(`files[${index}][type]`, "delete");
			formData.append(`files[${index}][uniqueId]`, uuidToDelete);
			index++;
		}

		arrayOfFilesToEdit?.forEach((item) => {
			if (!item.edit) return;
			const newFile = item.newFile;

			let newName = newFile.fileName?.includes(".")
				? newFile.fileName
				: `${newFile.fileName}.${newFile.fileExtension}`;

			formData.append(`files[${index}][file]`, newFile.file);
			formData.append(`files[${index}][type]`, "edit");
			formData.append(`files[${index}][nameForHeadset]`, newName ?? item.nameForHeadset);
			formData.append(`files[${index}][uniqueId]`, item.uniqueId);

			index++;
		});
        
        formData.append("csrfToken", csrfToken);
	}


	return (
		<div>
	  	 {uploadFilesContainer}
           <button 
            id="upload-files-form-submit" 
                className="d-none"
            type="button" 
            onClick={checkData}
        />
		</div>
	);
};

export default UploadFilesFormComponent;
